var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{attrs:{"id":"modal-success","hide-footer":"","hide-header":""}},[_c('p',{staticClass:"my-2 text-center"},[_vm._v("การชำระเงินสำเร็จ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }